module.exports = __webpack_public_path__ + "img/information.ca594396.svg";